import React, { useContext} from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import { Wrapper, Grid, Content ,Item} from "./styles";


export const LProjects = () => {
  const { theme } = useContext(ThemeContext);
  var list =
  [
  {"name":"Rate-It" , "logo":"https://github.com/tend2infinity/Rate-It-Project/blob/master/public/screenshots/rateit1.JPG?raw=true", "caption": "A website to nominate your favourite movies and see them climb up the leaderboard.", "link":"https://rate-it-project.netlify.app/"},
  {"name":"Fapino" , "logo":"https://github.com/savi-1311/content/blob/master/Capture7%20(2).PNG?raw=true", "caption": "A website to order and rate food.","link":"https://github.com/savi-1311/Fapino"},
  {"name":"Blog-App" , "logo":"https://github.com/savi-1311/content/blob/master/Screenshot%20from%202021-03-04%2023-50-46.png?raw=true", "caption": "An admin focussed website to upload blogs!", "link":"https://lockdown-blog.herokuapp.com/home"},
  {"name":"Realtime-Markdown-Editor" , "logo":"https://user-images.githubusercontent.com/56017960/109376507-e71c3d00-78ea-11eb-8838-920f3191be06.png", "caption": "See your markdown files getting into life with this markdown editor!","link":"https://savi-1311.github.io/Realtime-Markdown-Editor/"},
  {"name":"X-Meme" , "logo":"https://github.com/savi-1311/content/blob/master/Screenshot%20from%202021-03-05%2000-09-32.png?raw=true", "caption": "Like a meme? Post It!","link":"https://xmeme-frontend-savi.netlify.app/"},

  ]
  return (
    <Wrapper as={Container} id="skills">
    <h2>Web Projects!</h2><br></br>
      <Grid>
      {list.map((item) =>
      <Item>
      <Card theme={theme} style={{textAlign:"center"}} data-aos="flip-up">
              <Content>
                <a href = {item.link} style={{textDecoration:"none"}}><h2>{item.name}</h2></a>
                <h4>{item.caption}</h4>
                <img src={item.logo}></img>
              </Content>
              <br></br>
            </Card>
            </Item>
        )}
            
      </Grid>
    </Wrapper>
  );
};
